export default [
  {
    position: "absolute",
    top: 3.4,
    left: 12,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "dashboardsP3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Dashboards_Navigation_Home",
    index: 0,
  },
  {
    position: "absolute",
    top: 3.4,
    left: 27.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "dashboardsP3.ttTextTwo",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Dashboards_Navigation_TeamMembers",
    index: 1,
  },
  {
    position: "absolute",
    top: 3.4,
    left: 38.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "dashboardsP3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Dashboards_Navigation_Reports",
    index: 2,
  },
  {
    position: "absolute",
    top: 34.1,
    left: 21,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "dashboardsP3.ttTextFour",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Dashboards_Navigation_WorkforceInsightDashboard",
    index: 3,
  },
];
